import { useConnectionsQuery } from "@Components/shared/queries";
import SessionManager from "@Core/session";

const useActivityDetailsPresenter = (activityId: string) => {
    // ** Hooks ** //
    const { data: connections } = useConnectionsQuery();

    // ** Constants & Variables ** //
    const { userId: loggedInUserId } = SessionManager.getServiceUser();
    const urlParamUserId = new URLSearchParams(location.search).get("user");
    const isSelf = urlParamUserId === loggedInUserId;

    const connection = isSelf ? undefined : connections?.find((x) => x.userId === urlParamUserId);

    return {
        connection,
        connections,
    };
};

export default useActivityDetailsPresenter;
